import { useContext, forwardRef } from 'react';
import ConfigContext from '../contexts/ConfigContext';

const SlideContainer = forwardRef(({
  children,
  removeMinHeight,
  className = '',
  hideMobileHeaderBackground,
  removeWidths = false
}: any, ref: any) => {
  const { features } = useContext(ConfigContext);

  return (
    <div
      ref={ref}
      className={`relative md:shadow-[0px_20px_36px_-8px_rgba(0,0,0,0.1),_0px_1px_2px_rgba(0,0,0,0.05)] bg-white rounded-xl md:rounded-2xl px-6 md:px-10 py-8 md:py-[60px] mx-0 md:mx-auto ${
        removeMinHeight || removeWidths
          ? ''
          : features.showLanderConcept
          ? 'md:min-h-[500px] transition-[height] duration-500'
          : 'md:min-h-[580px] transition-[height] duration-500'
      } ${removeWidths ? 'md:w-fit !p-6' : 'md:w-[805px]'} ${className}`}
    >
      {features.showLanderConcept && !hideMobileHeaderBackground && (
        <div className="md:hidden absolute w-full h-[70px] bg-[#F4F3F0] top-0 left-0 border-b border-gray-300 z-0 rounded-t-xl md:rounded-t-2xl"></div>
      )}
      {children}
    </div>
  );
});

export default SlideContainer;
